import { Money } from "types/landlord/reports";

type Period = { end: string; start: string };

export enum StatementStatus {
  Finished = "finished",
  Created = "created"
}

export interface Statement {
  period: Period;
  id: number;
  total: Money;
  due_date: string;
  created_at: string;
  status: StatementStatus;
  sending_at?: string;
  updated_at?: string;
}
